
 export default ({
   name: 'App',
   components: {
   },
   data(){
     return {
       choice: null,
     }
   },
   methods: {
     choose(choice: any){
       if(choice === 'oculus'){
         this.$router.push({ path: '/oculus' });
        } else if (choice === 'web'){
         this.$router.push({ path: '/web' });
       } else if (choice === 'mob'){
        // this.$refs.audioPlayer.play();
         this.$router.push({ path: '/mob' });
       } 
     }
   }
 });
